var _circle, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessage2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18,
  fill: "#F5F5F5"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18,
  fill: "url(#Message2_svg__a)",
  style: {
    mixBlendMode: "soft-light"
  }
}), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18,
  stroke: "#E1E1E1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m22.854 27.354 4.61-17.672c.2-.762-.598-1.398-1.297-1.035L8.487 17.87c-.618.318-.654 1.189-.073 1.57l13.07 8.46a.908.908 0 0 0 1.37-.536z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m17.999 25.847-3.63 2.723v-5.446M14.486 23.06l8.958-9.92"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Message2_svg__a",
  x1: -15.546,
  x2: 18.018,
  y1: 18.502,
  y2: 52.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.055,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})))));
export default SvgMessage2;